module.exports = __webpack_public_path__ + "pc/img/work_detail5.0cae277a.jpg";